var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "deposit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0403\\u66F4\\u65B0--my-balance\\u5F39\\u7A97-assets",
    transform: "translate(-605.000000, -405.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(500.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-36\\u5907\\u4EFD",
    transform: "translate(80.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(14.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "deposit",
    transform: "translate(11.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7875,9.375 L21.95,6.5375 C22.0375,6.0125 22.175,5.525 22.35,5.1 C22.45,4.875 22.5,4.6375 22.5,4.375 C22.5,3.3375 21.6625,2.5 20.625,2.5 C18.575,2.5 16.7625,3.4875 15.625,5 L9.375,5 C5.575,5 2.5,8.075 2.5,11.875 C2.5,15.675 5.625,26.25 5.625,26.25 L12.5,26.25 L12.5,23.75 L15,23.75 L15,26.25 L21.875,26.25 L23.975,19.2625 L27.5,18.0875 L27.5,9.375 L24.7875,9.375 Z M16.25,11.25 L10,11.25 L10,8.75 L16.25,8.75 L16.25,11.25 Z M20,13.75 C19.3125,13.75 18.75,13.1875 18.75,12.5 C18.75,11.8125 19.3125,11.25 20,11.25 C20.6875,11.25 21.25,11.8125 21.25,12.5 C21.25,13.1875 20.6875,13.75 20,13.75 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.fd7c26fd4db1c50d5395106972b9b6dc.svg";
export { ForwardRef as ReactComponent };